import { createFileRoute, useRouter } from "@tanstack/react-router";

import { parseTopupsSearch } from "@/features/money";
import { TopupsPage } from "@/features/money/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/money/topups/")({
  validateSearch: strictSearch(parseTopupsSearch),
  component: Topups,
});

function Topups() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const router = useRouter();
  return (
    <TopupsPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
      hrefOf={(topupId) =>
        router.buildLocation({ to: "/money/topups/$topupId", params: { topupId } }).href
      }
      onOpen={(topupId) =>
        void router.navigate({ to: "/money/topups/$topupId", params: { topupId } })
      }
    />
  );
}
